module.exports = __webpack_public_path__ + "static/media/bahai.e57f2e2f.svg";